<template>
  <div class="balance-wrapper">
    <div class="balance-header">
      <div v-if="balancesList.length > 0" class="title">{{$t('message.settlement.capabilities')}}</div>
      <!-- <el-button size="small" class="mixed-button" @click="download" :loading="downloading">
        <i style="font-size:12px;" class="iconfont icon-Download"></i>
        {{$t('message.settlement.exportTransactionDetails')}}
      </el-button> -->
    </div>
    <ul class="balance-currency-list">
      <template v-for="(item, index) in balancesList">
        <li :key="index" class="balance-currency-item" @click="viewDetail(item)">
          <div class="left-wrapper">
            <el-image fit="scale-down" class="currency-img" :src="getCurrencyImage(item.currency) ? require(`@/assets/images/currency/${item.currency}.png`) : ''"></el-image>
            <div class="balance-info">
              <div class="currency-name">{{item.currency}}</div>
              <!-- <div class="bank-code"></div> -->
            </div>
            <!-- <div v-if="item.vaCount" class="va-count" @click="handleVa(item.currency, $event)">
              <span>{{item.vaCount}} {{ item.vaCount > 1 ? 'Accounts' : 'Account' }}</span>
            </div> -->
          </div>
          <div class="right-wrapper">
            <span class="balance-text">{{$t('message.settlement.availableBalance')}}</span>
            <span class="balance-amount">{{item.availBalance ? item.availBalance.amount : 0.00}}</span>
            <span class="iconfont icon-a-Link1"></span>
          </div>
        </li>
      </template>
    </ul>
    <div v-if="!isLoading && balancesList.length === 0" class="balance-empty-box">
      <empty-component
        :empty-title="$t('message.tableCommon.accountNotOpened')"
        :empty-icon="require('@/assets/images/table/img-not-opened.png')"
      ></empty-component>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

import { ShowSuccessMessage } from '@/components/modal/tips/message-tips';
import EmptyComponent from '@/components/table/empty-component.vue';
import GlobalData from '@/utils/global/index';
import { getCurrencyImage } from '@/utils/tools/currency';
import { initToday, getTodayParams } from '@/utils/tools/time';
import BalancesService from '@/views/settlement/api/settlement-balance';

export default {
  components: {
    EmptyComponent,
  },
  data() {
    return {
      downloading: false,
      balancesList: [],
      today: initToday(),
      isLoading: false,
      supportCurrencyList: [],
    };
  },
  async created() {
    const dict = await GlobalData.getDictList(['PAYOUT_SUPPORT_CURRENCY']);
    this.supportCurrencyList = dict.PAYOUT_SUPPORT_CURRENCY.map(item => item.value);

    this.httpGetAccountBalances();
  },
  computed: {
    ...mapGetters([
      'app',
    ]),
  },
  methods: {
    getCurrencyImage,
    ...BalancesService,
    download() {
      if (!this.downloading) {
        this.downloading = true;
        // await TransitionService.downloadTransaction(param);
        ShowSuccessMessage(this.$t('message.common.downloadTask'));
        this.downloading = false;
      }
    },
    viewDetail(item) {
      this.$router.push({
        path: '/wallet/balance/view',
        query: {
          acntId: item.acntId,
          currency: item.currency,
          subAcntType: 'AVAIL',
          businessType: this.businessType || '',
          ...getTodayParams('beginTime', 'endTime'),
        },
      });
      console.log('viewDetail');
    },
    handleVa(currency, event) {
      event.stopPropagation();
      this.$router.push({
        path: '/collection/virtual-account/list',
        query: {
          applyCurrency: currency,
        },
      });
    },
    httpGetAccountBalances() {
      this.isLoading = true;
      this.getAccountBalances().then(async (data) => {
        // if (`${this.app.userLogin.businessType}` === '0' || `${this.app.userLogin.businessType}` === '2') { // B2B/B2C 商户时，才显示 VA 账号统计
        //   try {
        //     const applyCurrencyList = data.map(item => item.currency);
        //     const res = await this.getVABalanceCount({ applyCurrencyList });
        //     const applyCurrencyPair = res.applyCurrencyPair || {};
        //     data.forEach(item => {
        //       item.vaCount = +(applyCurrencyPair[item.currency]);
        //     });
        //   } catch (err) {
        //     //
        //   }
        // }
        let list = data;
        if (`${this.app.userLogin.businessType}` === '0') { // Payout 商户只展示以下币种
          list = data.filter(item => this.supportCurrencyList.includes(item.currency));
        }
        this.balancesList = list;
        this.isLoading = false;
      }).catch(() => {
        this.isLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/styles/variables.scss';
.balance-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .title {
    line-height: 32px;
    font-size: 14px;
    color: $color-text-default-button;
    font-weight: 800;
  }
}
.balance-currency-list {
  padding-top: 5px;
  .balance-currency-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 80px;
    margin-bottom: 2px;
    transition: background-color 0.5s linear;
    cursor: pointer;
    padding: 0 20px 0 15px;
    border-radius: 4px;
    &:hover {
      background-color: $color-default;

      .left-wrapper {
        .va-count {
          background-color: rgba($color: $color-text-primary, $alpha: 0.2);
          color: $color-text-default-button;
        }
      }
    }
    .left-wrapper {
      display: flex;
      .currency-img {
        width: 42px;
        height: 42px;
        margin-right: 20px;
        border-radius: 8px;
      }
      .balance-info {
        min-width: 150px;
        display: flex;
        align-items: center;
      }
      .currency-name {
        font-size: 18px;
        font-weight: 800;
        line-height: 25px;
      }
      .bank-code {
        font-size: 14px;
        font-weight: normal;
        margin-top: 3px;
      }

      .va-count {
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 107px;
        height: 40px;
        background: $color-default;
        border-radius: 2px;
        padding: 0 12px;
        cursor: pointer;
        box-sizing: border-box;
        font-size: 16px;
        font-family: Avenir-Heavy, Avenir;
        font-weight: 800;
        color: $color-text-primary;
        line-height: 25px;
        margin-left: 20px;
      }
    }
    .right-wrapper {
      display: flex;
      align-items: center;
      .balance-text {
        font-size: 14px;
        font-weight: normal;
        line-height: 25px;
        margin-right: 10px;
      }
      .balance-amount {
        font-size: 18px;
        font-weight: 800;
        line-height: 25px;
        display: inline-block;
        min-width: 120px;
      }
      .iconfont {
        color: $color-text-default-button;
        font-size: 12px;
      }
    }
  }
}
.currency-add-wrapper {
  margin-top: 20px;
  padding-left: 15px;
  .currency-add-button {
    .button-text {
      margin-left: 20px;
      font-size: 18px;
      font-weight: 800;
      color: $color-text-default-button;
      line-height: 25px;
    }
  }
}

.balance-empty-box {
  margin-top: 200px;

  ::v-deep .empty-wrap {
    .icon-empty {
      width: auto;
      height: auto;
      margin-bottom: 30px;
    }
  }
}
</style>
